<template>
  <div class="heading-6 article-type-eyebrow">
	<i :class="iconClass"></i><slot>Heading</slot>
  </div>
</template>

<script>
export default {
	props: {
		icon:{
			type: String,
			default: "bi-eye"
		}
	},
	computed: {
		iconClass() {
			var classes = {};
			var iconClass = this.icon;
			classes["bi"] = true;
			classes[iconClass] = true;
			return classes;

		}
	}
}
</script>

<style lang="scss">
	.article-type-eyebrow {
		color: $blueText;
		display: inline-block;
		text-transform: uppercase;
		font-weight: 700;
	}

	.icon-news {
		background-image: get-icon( 'news', $blueText );
		height: 15px;
		width: 15px;
		margin-right: 4px;
		position: relative;
		//top: -0.125em;

	}

	.icon-eye {
		background-image: get-icon( 'eye', $blueText );
		height: 15px;
		width: 16px;
		margin-right: 4px;
		margin-bottom: -1px;
		position: relative;
		//top: -0.125em;

	}

	.icon-award {
		background-image: get-icon( 'award-icon', $blueText );
		height: 15px;
		width: 15px;
		margin-right: 2px;
		top: -1px;

		position: relative;
	}

	.icon-heart-circle {
		background-image: get-icon( 'heart-circle-icon', $blueText );
		height: 15px;
		width: 15px;
		margin-right: 2px;
		top: -1px;

		position: relative;
	}

	.icon-idea {
		background-image: get-icon( 'idea-icon', $blueText );
		height: 15px;
		width: 15px;
		margin-right: 2px;
		top: -1px;

		position: relative;
	}

	.icon-star {
		background-image: get-icon( 'star-icon', $blueText );
		height: 15px;
		width: 15px;
		margin-right: 2px;
		top: -1px;

		position: relative;
	}

	.icon-school {
		background-image: get-icon( 'school-icon', $blueText );
		height: 15px;
		width: 15px;
		margin-right: 2px;
		position: relative;
	}

	.icon-video {
		background-image: get-icon( 'video-icon', $blueText );
		height: 17.5px;
		width: 17.5px;
		margin-left: -1px;
		margin-right: 2px;
		position: relative;
		transform: scale(0.85);
		top: -1px;
	}

	.icon-podcast {
		background-image: get-icon( 'podcast-icon', $blueText );
		height: 19.5px;
		width: 13.5px;
		margin-left: 1px;
		margin-right: 2px;
		margin-bottom: -4px;
		position: relative;
		transform: scale(0.9);
	}
	.icon-chart {
		background-image: get-icon( 'chart-icon', $blueText );
		height: 17.5px;
		width: 17.5px;
		margin-left: -2px;
		margin-right: 2px;
		position: relative;
		transform: scale(0.7);
		top: -1px;
	}
	.icon-mentoring {
		background-image: get-icon( 'mentoring-icon', $blueText );
		height: 15.7px;
		width: 15px;
		margin-right: 2px;
		position: relative;
	}

	.icon-search {
		background-image: get-icon( 'search-icon', $blueText );
		height: 15.7px;
		width: 15px;
		margin-right: 2px;
		position: relative;
	}

	.background-is-navy
	{
		.icon-news {
			background-image: get-icon( 'news', $orangeText );
		}

		.icon-eye {
			background-image: get-icon( 'eye', $orangeText );
		}

		.icon-award {
			background-image: get-icon( 'award-icon', $orangeText );
		}

		.icon-heart-circle {
			background-image: get-icon( 'heart-circle-icon', $orangeText );
		}

		.icon-idea {
			background-image: get-icon( 'idea-icon', $orangeText );
		}

		.icon-star {
			background-image: get-icon( 'star-icon', $orangeText );
		}

		.icon-school {
			background-image: get-icon( 'school-icon', $orangeText );
		}

		.icon-mentoring {
			background-image: get-icon( 'mentoring-icon', $orangeText );
		}

		.icon-search {
			background-image: get-icon( 'search-icon', $orangeText );
		}

		.icon-video {
			background-image: get-icon( 'video-icon', $orangeText );
		}

		.icon-podcast {
			background-image: get-icon( 'podcast-icon', $orangeText );
		}

		.icon-chart {
			background-image: get-icon( 'chart-icon', $orangeText );

		}

		.article-type-eyebrow {
			color: $orangeText;
		}
	}

	.emphasized-content-section-main.background-is-navy
	{
		.icon-news {
			background-image: get-icon( 'news', $lightBlue );
		}

		.icon-eye {
			background-image: get-icon( 'eye', $lightBlue );
		}

		.icon-award {
			background-image: get-icon( 'award-icon', $lightBlue );
		}

		.icon-heart-circle {
			background-image: get-icon( 'heart-circle-icon', $lightBlue );
		}

		.icon-idea {
			background-image: get-icon( 'idea-icon', $lightBlue );
		}

		.icon-star {
			background-image: get-icon( 'star-icon', $lightBlue );
		}

		.icon-school {
			background-image: get-icon( 'school-icon', $lightBlue );
		}

		.icon-mentoring {
			background-image: get-icon( 'mentoring-icon', $lightBlue );
		}

		.icon-search {
			background-image: get-icon( 'search-icon', $lightBlue );
		}

		.icon-video {
			background-image: get-icon( 'video-icon', $lightBlue );
		}

		.icon-podcast {
			background-image: get-icon( 'podcast-icon', $lightBlue );
		}

		.icon-chart {
			background-image: get-icon( 'chart-icon', $lightBlue );
		}

		.article-type-eyebrow {
			color: $lightBlue;
		}
	}

.related-articles {
	.icon-chart,
	.icon-eye,
	.icon-news,
	.icon-podcast,
	.icon-video {
		display: block;
		float: left;
		padding: 11px 10px;
		background-repeat: no-repeat;
		background-position: 0px 4px;
		margin-right: 7px;
	}
}

/* New Bootstrap Icons */

/* New Bootstrap Icons */
i.bi {
	font-size: 17px;
	margin-right: 8px;
	color: $blueText;
}

	.background-is-navy	{
		i.bi {
			color: $orangeText;
		}
	}

	.emphasized-content-section-main.background-is-navy	{
		i.bi {
			color: $lightBlue;
		}
	}

</style>
